<template>
  <div
    class="form-container"
    @scroll="scrollHandler"
    :class="{'mobile': $vuetify.breakpoint.xs}"
  >
    <v-fade-transition>
      <div
        v-if="userform"
        class="form-header-view elevation-3"
        :class="{'mobile-form-header': $vuetify.breakpoint.xs}"
      >
        <v-expand-transition>
          <div
            v-show="showCaseDetails"
            class="form-header-sneak"
          >
            <div
              class="case-info"
            >
              <v-icon
                size="16"
                style="padding-right: 5px;"
              >
                mdi-briefcase
              </v-icon>

              <b>{{userform.case.case_type.name}}</b>
              <span
                v-if="userform.case.case_number"
              >
                - {{userform.case.case_number}}
              </span>
              <span
                v-if="userform.case.case_title"
              >
                - <i>{{userform.case.case_title}}</i>
              </span>
            </div>
          </div>
        </v-expand-transition>
        <div
          class="form-header-persistent"
        >
          <div
            class="save-state"
            :class="{'offline': offline, 'saving': loading || pendingSaves > 0}"
          >
            <span v-if="!offline">
              <span v-if="loading || pendingSaves > 0"><v-icon class="spin">sync</v-icon></span>
              <span v-else> <v-icon color="black">save</v-icon></span>
            </span>
            <span
              v-else
            >
              <v-icon>warning</v-icon>
            </span>
          </div>
          <div
            class="form-info"
            style="flex-grow: 1;"
          >
            {{ userform.name }}
          </div>
          <div
            class="form-navigation"
          >
            <v-btn
              dark
              flat
              icon
              color="#262626"
              id="nav-anchor"
              @click="showNavigation = !showNavigation"
            >
              <v-icon>
                mdi-table-of-contents
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-fade-transition>
    <v-fade-transition>
      <div
        v-if="!loading"
        class="form-container-view"
      >
        <div
          v-if="isReadOnly"
        >
          <v-alert
            :value="true"
            type="warning"
          >
            This form is currently read only. Please contact your law office if you need to make changes.
          </v-alert>
        </div>
        <v-form
          ref="formContainer"
        >
          <UserFormPartList
            v-if="!loading"
            :user-form-id="userform.id"
            :parts="userform.sections"
          />
        </v-form>
        <v-card
          v-if="!isReadOnly"
          flat
        >
          <v-card-actions
            style="margin-bottom: 50px;"
          >
            <v-spacer/>
            <v-btn
              color="primary"
              @click="showSubmitDialog"
            >
              Submit for Review
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-fade-transition>
    <v-dialog
      v-model="loading"
      persistent
      width="500"
    >
      <v-card
        color="white"
      >
        <v-card-text>
          <h2>Please Wait...</h2>
          <v-progress-linear
            indeterminate
            color="blue"
            class="mb-0"
          />
          <br/>
          <h4 style="color:grey; font-weight:300;">{{ app_name }} saves automatically. When you are finished, click Submit for Review to submit to your law office.</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showNavigation"
      width="600"
    >
      <UserFormNavigator
        v-if="showNavigation"
        :userform="userform"
        @dismiss="showNavigation = false"
      />
    </v-dialog>

    <v-dialog
      v-model="saveDialog"
      width="500"
      persistent
      transition="fade-transition"
    >
      <v-card
        color="white"
      >
        <div
          style="display: flex;flex-direction: column;justify-content: center;align-items: center;background: #004D40;color: white;padding: 20px;transition: background 1s ease;"
          :style="{'background': requiredComplete ? '#33691E' : '#E65100'}"
        >
          <v-icon
            color="white"
            size="72"
          >
            {{ requiredComplete ? 'assignment_turned_in' : 'assignment_late' }}
          </v-icon>
          <div
            style="font-size: 18px;font-weight: 700;padding-top: 10px;"
          >
            {{ requiredComplete ? 'Ready to Submit' : 'Not Ready to Submit' }}
          </div>
        </div>
        <v-card-text v-if="(pendingSaves == 0) && requiredComplete">
          <span>
            You are about to submit this form for review. Please ensure all information on this form is accurate and complete before submitting.<br /><br />
            If you need to make changes after submitting, contact <span class="legalFoot"/> to unlock the form.<br /><br />
          </span>
        </v-card-text>
        <v-card-text
          v-else-if="!requiredComplete"
          style="text-align:center;"
        >
          <b>One or more questions require your attention before you can submit.</b>
          <br />
          There may be required, unanswered questions or incomplete answers preventing you from submitting this document.
          <br /><br />
          Questions that require your attention have been highlighted. Please select 'Go Back' and resolve these issues before submitting.
        </v-card-text>
        <v-card-text v-else>
          <span><b>You have an answer currently saving or that has failed to save.</b> Please check your answers or wait a moment before submittng, and try again.</span>
        </v-card-text>
        <v-progress-linear
          v-if="submitting"
          indeterminate
        />
        <v-card-actions>
          <v-spacer/>
          <v-btn
            flat
            color="grey"
            :disabled="submitting"
            @click="saveDialog = false"
          >
            go back
          </v-btn>
          <v-btn
            v-show="pendingSaves == 0 && requiredComplete"
            flat
            color="primary"
            :disabled="submitting"
            @click="submitForm()"
          >
            I Understand, Submit
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="docusignDialog"
      width="500"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card
        color="white"
        style="border: 3px solid rgba(255,0,0,0.5) !important;"
      >
        <v-card-text
          style="text-align:center;"
        >
          <div style="font-size: 24px;">Please Sign this Document</div>
          <div style="font-size: 16px;margin: 10px;"><u>{{userform ? userform.name : 'This form'}}</u> must be signed upon completion. Your document isn't complete until it's signed.</div><br />
          <div style="font-size: 14px;">Click "Sign Now" below to sign this document. You'll be redirected back to {{ app_name }} once you've finished signing.</div><br />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="yellow"
            @click="signForm()"
          >
            Sign Now
          </v-btn>
          <v-spacer/>
        </v-card-actions>
        <hr style="margin-top: 10px;"/>
        <div style="margin: 10px;text-align:left;font-size: 10px;">
          If you need to make changes to a document after submitting, please contact <span class="legalFoot"></span> for assistance.
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import api from '@/api'
import UserFormNavigator from './UserFormNavigator'
import UserFormPartList from './UserFormPartList'
import HelloSign from 'hellosign-embedded'

export default {
  name: 'Form',
  components: {
    UserFormNavigator,
    UserFormPartList
  },
  props: ['offline'],
  data () {
    return {
      userform: null,
      loading: true,
      saveDialog: false,
      showNavigation: false,
      requiredComplete: false,
      docusignDialog: false,
      docusignUrl: null,
      hellosign: null,
      showCaseDetails: true,
      submitting: false,
    }
  },
  created () {
    if (this.$route.params.form_id) {
      this.fetch()
    }
  },
  computed: {
    ...mapGetters('userform', [
      'pendingSaves',
      'isReadOnly',
      'getLocalSigning',
      'getAdoptSignature',
      'getUserLocation'
    ]),
    ...mapState('userform', [
      'handleBypass'
    ])
  },
  watch: {
    pendingSaves () {
      if (this.pendingSaves > 0) {
        window.onbeforeunload = function () {
          return true
        }
      } else {
        window.onbeforeunload = null
      }
    },
    saveDialog () {
      if (this.saveDialog) {
        this.$store.state.userform.formSubmissionAttempt = true
      }
    }
  },
  methods: {
    ...mapMutations('userform', [
      'setAnswerDatabase',
      'setReadOnly',
      'setNestedTemplate',
      'setLocalSigning'
    ]),
    showSubmitDialog () {
      if (this.getLocalSigning && !this.getAdoptSignature)
        this.requiredComplete = false
      else
        this.requiredComplete = this.$refs.formContainer.validate()
      this.saveDialog = true
    },
    scrollHandler(e) {
      this.showCaseDetails = e.target.scrollTop > 100 ? false : true
    },
    fetch () {
      this.loading = true
      this.$store.state.userform.formSubmissionAttempt = false
      api.userform.contactUserForm.get(this.$route.params.form_id)
      .then(userForm => {
        this.userform = userForm
        this.setNestedTemplate(this.userform)
        this.setLocalSigning(this.userform.local_signing)
        if (this.userform.is_signing) {
          api.userform.contactUserForm.getDocuSign(this.$route.params.form_id)
          .then(response => {
            if (response.provider == "hellosign") {
              this.hellosign = response
            } else if (response.provider == "docusign") {
              this.docusignUrl = response.redirect_url
            }
            this.signForm()
          })
        } else {
          api.userform.contactUserForm.getAnswerDb(this.$route.params.form_id)
          .then(answerDb => {
            this.setAnswerDatabase(answerDb)
            this.setReadOnly(this.userform.client_readonly)
            setTimeout(() => {
              this.loading = false
              if (localStorage.getItem('lastQuestion:' + this.userform.id)) {
                this.$vuetify.goTo("#" + localStorage.getItem('lastQuestion:' + this.userform.id), { duration: 1000, offset: -250, easing: 'easeInOutCubic' })
              }
            }, 5000)
          })
        }
      })
    },
    submitForm () {
      this.submitting = true
      localStorage.removeItem('lastQuestion:' + this.userform.id)
      api.userform.contactUserForm.submit(this.userform.id, this.getAdoptSignature, JSON.stringify(this.getUserLocation))
        .then(response => {
          this.submitting = false
          this.saveDialog = false
          if (response.redirect_url || response.hellosign) {
            this.docusignDialog = true
            if (response.provider == "hellosign") {
              this.hellosign = response
            } else if (response.provider == "docusign") {
              this.docusignUrl = response.redirect_url
            }
          } else if (response.outage) {
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { outage: true }})
          } else if (response.sign == true) {
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 4 }})
          } else {
            var qs = {}
            if (response.outage)
              qs['outage'] = true
            if (response.message)
              qs['message'] = response.message
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: qs})
          }
          this.loading = false
        })
        .finally(() => {
          this.loading = false
          this.saveDialog = false
        })
    },
    signForm () {
      if (this.hellosign) {
        this.loading = false
        this.setReadOnly(true)

        if (this.hellosign.error) {
          this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 2, message: this.hellosign.error_msg }})
        } else {
          const client = new HelloSign();

          client.open(this.hellosign.hellosign, {
            clientId: this.hellosign.client_id,
            skipDomainVerification: this.hellosign.test_mode || false,
            hideHeader: true
          })

          client.on("sign", (data) => {
            client.close()
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 1 }})
          })

          client.on("cancel", (data) => {
            client.close()
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 0 }})
          })

          client.on("error", (data) => {
            client.close()
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 2 }})
          })

          client.on("decline", (data) => {
            client.close()
            this.$router.replace({name: 'UserFormSubmitted', params: { id: this.$route.params.id, form_id: this.userform.id }, query: { signed: 3 }})
          })
        }

      } else {
        window.open(this.docusignUrl, "_self")
      }
    },
    isMobile () {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.pendingSaves > 0 && !this.handleBypass) {
      const alertDialog = window.confirm('Are you sure you want to leave? You have unsaved changed!')
      if (alertDialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style scoped>

.form-header-view {
  display: flex;
	flex-direction: column;
  background: white;
  position: fixed;
  left:125px;
  right:0;
  top: 0;
  z-index:9;
}

.mobile-form-header {
  left: 0 !important;
}

.form-header-persistent {
  display: flex;
  align-items: center;
}

.form-header-sneak {
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  background: #ECEFF1;
}

.save-state {
  width: 50px;
  aspect-ratio: 1/1;
  display: flex;
	justify-content: center;
	align-items: center;
}

.case-info {
  padding: 5px;
  padding-left:0;
}

.form-container {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  overflow: auto;
  position: relative;
}

.form-container.mobile {
  max-height: calc(100vh - 56px - var(--mobile-padding-bottom)) !important;
}

.form-container-view {
  padding: 25px;
  padding-top: 115px;
}

.header {
  text-align:center;
  font-weight:700;
  top: 0px;
}

#userform-navigator {
  position: fixed;
  width: 250px;
  height: 100%;
  overflow-y: auto;
}

.spin {
    -webkit-animation: spin 1000ms infinite linear;
    animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

.v-list__tile__title, .v-select__selections {
  text-transform: capitalize;
}
</style>
